import { useMutation } from '@tanstack/react-query';
import { bulkImportIsbns } from './apiBulkImportIsbns';
import { useDispatch } from 'react-redux';
import { showNotification, TYPE_ERROR } from '../../../store/notifications/actions';
import { invalidateCartSummaryQuery } from '../../../api/shopping-cart/useCartSummaryQuery';
import { invalidateShoppingCartProducts } from '../../../api/shopping-cart/useShoppingCartProducts';
import { useTranslation } from 'react-i18next';

export const useBulkImportIsbns = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    return useMutation(bulkImportIsbns, {
        onSuccess: data => {
            dispatch(showNotification(data.response));
            invalidateCartSummaryQuery().then();
            invalidateShoppingCartProducts().then();
        },
        onError: () => {
            dispatch(showNotification(t('notifications.useBulkImportIsbns.error'), TYPE_ERROR));
        }
    });
};
